import * as Grid from 'antd/lib/grid';
import type { RowProps } from 'antd/lib/grid';

function Row(props: RowProps) {
  return <Grid.Row {...props} />;
}

Row.defaultProps = {
  gutter: 16,
};

const { Col } = Grid;

export { Row, Col };

export type { ColProps, RowProps } from 'antd/lib/grid';
